import { useState } from "react";
import { fetchStochasticInvoicesCsv } from "@/api/fetchStochasticInvoices/fetchStochasticInvoicesCsvApi";
import { downloadFile } from "@/utils/downloadFile";
import { FetchStochasticInvoicesRequest } from "@/api/fetchStochasticInvoices/types";

export function useDownloadInvoicesCsv() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const downloadInvoicesCsv = async (
    requestParams: FetchStochasticInvoicesRequest,
  ) => {
    setLoading(true);
    setError(null);
    try {
      const blob = await fetchStochasticInvoicesCsv(requestParams);
      const timestamp = new Date().toISOString().split("T")[0];
      const fileName = `invoices-${timestamp}.csv`;
      downloadFile(blob, fileName);
    } catch (err: unknown) {
      if (err instanceof Error) {
        console.error("Invoice CSV download error:", err.message);
        setError(err.message);
      } else {
        setError("Failed to download invoices CSV");
      }
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    downloadInvoicesCsv,
    error,
  };
}
